/* Common Imports */

import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

/* Component Imports */

import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
  Link,
  Snackbar,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiAlert from "@material-ui/lab/Alert";

/* Data Imports */

import AppConfig from "../../AppConfig";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    padding: "1rem",
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  socialButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "space-evenly",
    width: "100%",
  },
  link: {
    margin: "1rem",
  },
  socialButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "6rem",
    width: "6rem",
    borderRadius: "5px",
    [theme.breakpoints.down("sm")]: {
      height: "3rem !important",
      width: "3rem !important",
    },
  },
  socialIcon: {
    height: "64px",
    width: "64px",
    [theme.breakpoints.down("md")]: {
      height: "32px",
      width: "32px",
    },
  },
  facebook: {
    background: "#395197",
  },
  instagram: {
    background:
      "linear-gradient(139.58deg, #FA9954 0%, #DF2264 40.92%, #C32795 63.02%, #663CCC 100%)",
  },
  pinterest: {
    background: "#AC070B",
  },
  twitter: {
    background: "#00A8FF",
  },
  linkedin: {
    background: "#3D83D9",
  },
  whatsapp: {
    background: "#01B456",
  },
  email: {
    background: "#ffffff",
  },
  copyRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "2rem",
    marginBottom: "2rem",
    width: "100%",
    padding: "0rem 1rem 0rem 1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  copyInput: {
    width: "100%",
    margin: 0,
    height: "3.5rem",
    borderRadius: "5px 0px 0px 5px",
    [theme.breakpoints.down("sm")]: {
      height: "3.5rem !important",
    },
  },
  copyBtn: {
    margin: 0,
    padding: 0,
    borderRadius: "0px 5px 5px 0px",
    height: "2.5rem",
    [theme.breakpoints.down("sm")]: {
      height: "2.5rem !important",
    },
    color: "#FFFFFF",
    background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
  },
  copyIcon: {
    [theme.breakpoints.down("sm")]: {
      height: "3rem !important",
      width: "3rem !important",
    },
  },
  primaryButton: {
    color: "#FFFFFF",
    background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
  },
}));

const ShareModal = (props) => {
  const classes = useStyles();
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleClickCopy = (prop) => (event, value) => {
    document.getElementById("copyText").select();
    document.execCommand("copy");
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <React.Fragment>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          Link Copied !
        </Alert>
      </Snackbar>
      <Dialog
        className={classes.modal}
        onClose={props.onClose}
        aria-labelledby="share-modal"
        open={props.open}
        maxWidth="lg"
      >
        <DialogTitle id="share-modal-title" onClose={props.onClose}>
          Share this property
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={props.onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <div className={classes.socialButtonsContainer}>
            {/* Facebook */}
            <Link
              className={classes.link}
              href={
                "https://facebook.com/sharer/sharer.php?u=" +
                props.url +
                "&quote=Have%20a%20look%20at%20this%20property%20from%20Beegru."
              }
              target="_blank"
              aria-label="Share via Facebook"
              title="Share via Facebook"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.facebook}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/facebook-white.svg"
                />
              </Paper>
            </Link>

            {/* Instagram */}
            {/* <Link
              className={classes.link}
              href={
                "https://facebook.com/sharer/sharer.php?u=" +
                props.url +
                "&quote=Have%20a%20look%20at%20this%20property%20from%20Beegru."
              }
              target="_blank"
              aria-label="Share via Instagram"
              title="Share via Instagram"
              rel="noopener"
            >
              <Paper
              elevation={2}
              className={`${classes.socialButton} ${classes.instagram}`}
            >
              <img
                  alt={AppConfig.imageAltText}

                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/instagram-white.svg"
                />
            </Paper>
          </Link> */}

            {/* Pinterest */}
            <Link
              className={classes.link}
              href={
                "https://pinterest.com/pin/create/button/?url=" +
                props.url +
                "&amp;media=http%3A%2F%2Fsharingbuttons.io&amp;description=Have%20a%20look%20at%20this%20property%20from%20Beegru."
              }
              target="_blank"
              aria-label="Share via Pinterest"
              title="Share via Pinterest"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.pinterest}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/pinterest-white.svg"
                />
              </Paper>
            </Link>

            {/* Twitter */}
            <Link
              className={classes.link}
              href={
                "https://twitter.com/intent/tweet/?text=Have%20a%20look%20at%20this%20property%20from%20Beegru.&url=" +
                props.url
              }
              target="_blank"
              aria-label="Share via Twitter"
              title="Share via Twitter"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.twitter}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/twitter-white.svg"
                />
              </Paper>
            </Link>

            {/* LinkedIn */}
            <Link
              className={classes.link}
              href={
                "https://www.linkedin.com/shareArticle?mini=true&url=" +
                props.url +
                "&title=Have+a+look+at+this+property+from+Lighter%20Advisory&summary=Have+a+look+at+this+property+from+Lighter%20Advisory&source=LinkedIn"
              }
              target="_blank"
              aria-label="Share via LinkedIn"
              title="Share via LinkedIn"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.linkedin}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/linkedin-white.svg"
                />
              </Paper>
            </Link>

            {/* Whatsapp */}
            <Link
              className={classes.link}
              href={
                "https://wa.me/?text=Have%20a%20look%20at%20this%20property%20from%20Lighter%20Advisory" +
                props.url
              }
              target="_blank"
              aria-label="Share via Whatsapp"
              title="Share via Whatsapp"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.whatsapp}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/whatsapp-white.svg"
                />
              </Paper>
            </Link>

            {/* Email */}
            <Link
              className={classes.link}
              href={
                "mailto:?&subject=Have%20a%20look%20at%20this%20property%20from%20Beegru.&body=" +
                props.url
              }
              target="_blank"
              aria-label="Share via Email"
              title="Share via Email"
              rel="noopener"
            >
              <Paper
                elevation={2}
                className={`${classes.socialButton} ${classes.email}`}
              >
                <img
                  alt={AppConfig.imageAltText}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className={classes.socialIcon}
                  height={64}
                  width={64}
                  src="/images/icons/social/email.svg"
                />
              </Paper>
            </Link>
          </div>

          <div className={classes.copyRow}>
            <TextField
              id="copyText"
              label="or copy this link"
              className={classes.copyInput}
              readOnly
              value={props.url}
            />
            <Button
              variant="contained"
              className={classes.copyBtn}
              onClick={handleClickCopy("copyText")}
            >
              <img
                alt={AppConfig.imageAltText}
                loading="lazy"
                referrerPolicy="no-referrer"
                height={24}
                width={24}
                src="/images/icons/social/copy-white.svg"
              />
            </Button>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            label="Close"
            onClick={props.onClose}
            className={classes.primaryButton}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ShareModal;
